<template>
  <v-app>
    <router-view name="Header"></router-view>
    <v-content>
      <router-view />
    </v-content>
    <!-- ダミー -->
    <div style="height:100px"></div>
  </v-app>
</template>

<script>
//共通css
require("./css/project.css");

</script>

